import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"; 
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
// import ReactHtmlParser from 'react-html-parser';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { MSG_SKILL_INDEX_UPDATE_ERROR} from '../../../configs/msgConfigs';
import { LBL_SETTINGS, LBL_SKILLS, LBL_SKILL, LBL_SLNUM, LBL_CERTIFICATE_MANDATORY, LBL_CERTIFICATE_NEEDED, LBL_ACTIVE, LBL_SKILL_DISPLAY_INDEX} from '../../../configs/labelConfigs';
import {LOGIN_AFFILIATE_GROUP, ROUTE_AFFILIATE_REFRESH,PAGENUMROWS_AFFILIATE} from '../../../configs/staticConfigs'; // ROUTE_REFRESH,

import Toast from '../../commons/helpers/toast';



import { aflt_skillListAction,  updateSkillIndexAction } from '../../../actions/settings/affiliates/aflt_skillActions';
import { SKILL_LIST_AFFILIATE_SUCCESS, UPDATE_SKILL_INDEX_SUCCESS, UPDATE_SKILL_INDEX_ERROR} from '../../../actions'; 

import {clearAction} from '../../../actions/commonActions';
  

  class DragTrComponent extends React.Component {
    render() {
      const { children = null, rowInfo } = this.props;
      if (rowInfo) {
        const { original, index } = rowInfo;
        const { slnum } = original;
        return (
          <Draggable key={slnum} index={index} draggableId={slnum}>
            {(draggableProvided, draggableSnapshot) => (
              <div
                ref={draggableProvided.innerRef}
                {...draggableProvided.draggableProps}
                {...draggableProvided.dragHandleProps}
              >
                <ReactTable.defaultProps.TrComponent style={{ width: '100%' }}>
                  {children}
                </ReactTable.defaultProps.TrComponent>
              </div>
            )}
          </Draggable>
        );
      } else
        return (
          <ReactTable.defaultProps.TrComponent  >
            {children}
          </ReactTable.defaultProps.TrComponent>
        );
    }
  }
  
  class DropTbodyComponent extends React.Component {
    render() {
      const { children = null } = this.props;
  
      return (
        <Droppable droppableId="droppable">
          {(droppableProvided, droppableSnapshot) => (
            <div ref={droppableProvided.innerRef}>
              <ReactTable.defaultProps.TbodyComponent  >
                {children}
              </ReactTable.defaultProps.TbodyComponent>
            </div>
          )}
        </Droppable>
      );
    }
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };
  
class AfltSkillDisplayIndexComponent extends Component { 

    constructor(props){
        super(props)

        this.state = {
            formErrors : {}, 
            skillList: [],  
            skillList_newIndex: [],
            skillData: {},
            activePage:1,
            startIndex : 0, 
            endIndex : 3,
            perPageCount: PAGENUMROWS_AFFILIATE,
            sortField:'skill_name',
            sortOrder:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            data: [],
            numSkills:0,
            displayIndexClicked:0
        }
    }

    handleDragEnd = result => {
        if (!result.destination) {
          return;
        }
    
        const skillList = reorder(
          this.state.skillList,
          result.source.index,
          result.destination.index
        );
        
        let newObj = []; 
        let indexDataObj = [];
        skillList.forEach((item, index) => {
            item.slnum = String((index+1))
            item.index = String((index+1))
            newObj.push(item);
            indexDataObj.push({skill_id: Number(item.id), index: Number(index+1)}); 
        })

        this.props.updateSkillIndexAction(indexDataObj); 
        // [{"skill_id": 102, "index": 7}, {"skill_id": 101, "index": 2}, {"skill_id": 97, "index": 3}]
        this.setState({ skillList_newIndex:newObj});
    };
      

    getTrProps = (state, rowInfo) => {
        //  console.log(rowInfo);
        return { rowInfo };
    };

    componentDidMount() { 
        document.body.classList.add('body-affiliate'); 
        let skillList = []; 
        let len = 0; 
        if(this.props.skillList && Array.isArray(this.props.skillList) && this.props.skillList.length) {
            len = this.props.skillList.length; 
            skillList = [];
            this.props.skillList.forEach((rObj, index) => {
                rObj.slnum = String((index+1));
                skillList.push(rObj)
            })
        }
        this.setState({skillList,numSkills:len}); 

        // this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField}); 
    }   
    

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    setToasterState(isEnabled,message,isSucces){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    componentDidUpdate(prevProps) {       
        const { status, activity, numRows, totalPage,errorData, displayIndexClicked } = this.props;
        if(Number(displayIndexClicked) && Number(displayIndexClicked) > Number(this.state.displayIndexClicked)) {
            // this.props.aflt_skillListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField}); 
            let len = 0; 
            let newSkillList = [];
            if(this.props.skillList && Array.isArray(this.props.skillList) && this.props.skillList.length) {
                len = this.props.skillList.length; 
                this.props.skillList.forEach((rObj, index) => {
                    rObj.slnum = String((index+1));
                    newSkillList.push(rObj)
                })
            }
            this.setState({displayIndexClicked:displayIndexClicked,skillList:newSkillList,numSkills:len}); 
        }

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            var arrResp = activity.split('~~'); 
            var actString = arrResp[0]; 
            let errMsg = '';
            
            if(actString===UPDATE_SKILL_INDEX_SUCCESS) { 
                let skillList = this.state.skillList_newIndex; 
                this.setState({skillList:skillList});
            }
            else if(actString===UPDATE_SKILL_INDEX_ERROR) { 
                this.setToasterState(true,MSG_SKILL_INDEX_UPDATE_ERROR,false);
                console.log(JSON.stringify(errorData))
            }

            if(actString===SKILL_LIST_AFFILIATE_SUCCESS) { 
                let skillList = []; 
                let len = 0; 
                if(this.props.skillsList && Array.isArray(this.props.skillsList) && this.props.skillsList.length) {
                    len = this.props.skillsList.length; 
                    skillList = [];
                    this.props.skillsList.forEach((rObj, index) => {
                        rObj.slnum = String((index+1));
                        skillList.push(rObj)
                    })
                }
                this.setState({skillList,numSkills:len})
            }
        }   
    }

       
    render(){
        const {
            activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,data          
        } = this.state

        const { skillsList, totalPage, status} = this.props;   
        
        if(status===401 || status===403){
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        return(
            <>
            <div className="col-md-12">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    {/* <div className="box-head">
                        <div className="to-right">                                   
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div> */}

                    <div className="box-content">
                        {Number(this.state.numSkills)===0 &&  
                        <DragDropContext onDragEnd={this.handleDragEnd}>
                            <ReactTable
                                showPagination={false}
                                TrComponent={DragTrComponent}
                                TbodyComponent={DropTbodyComponent}
                                getTrProps={this.getTrProps}
                                data={[]}
                                columns={[
                                    {   accessor: "slnum",
                                        width: 75,
                                        Header: () => ( <div className="table-header-center">{LBL_SLNUM}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> ) 
                                    },  
                                    {   accessor: d => d.skill_name,
                                        id: "skill_name",   
                                        Header: () => ( <div className="table-header-left">{LBL_SKILLS}</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                ]}
                                defaultPageSize={2}
                                className="table -striped -highlight"
                            />
                        </DragDropContext>}

                        {Number(this.state.numSkills) > 0 && <DragDropContext onDragEnd={this.handleDragEnd}>
                            <ReactTable
                                showPagination={false}
                                TrComponent={DragTrComponent}
                                TbodyComponent={DropTbodyComponent}
                                getTrProps={this.getTrProps}
                                data={this.state.skillList}
                                columns={[
                                    {   accessor: "slnum",
                                        width: 75,
                                        Header: () => ( <div className="table-header-center">{LBL_SLNUM}</div>),
                                        Cell: row => ( <div className="table-td-text-center">{row.value}</div> ) 
                                    },  
                                    {   accessor: d => d.skill_name,
                                        id: "skill_name",  
                                        Header: () => ( <div className="table-header-left">{LBL_SKILLS}</div>),
                                        Cell: row => ( <div className="table-td-text-left">{row.value}</div> )
                                    },
                                    
                                    
                                ]} 
                                defaultPageSize={Number(this.state.numSkills)}
                                className="table -striped -highlight"
                            />
                        </DragDropContext> } 
                                
                    </div> 
                </div>

            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    console.log('activity:'+state.afltSkills.activity); 
    return {
        skillsList : state.afltSkills.items,
        totalPage:state.afltSkills.totalPage,
        skill:state.afltSkills.item,
        status:state.afltSkills.status,
        activity:state.afltSkills.activity,
        numRows:state.afltSkills.numRows,
        errorData: state.afltSkills.errorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_skillListAction:aflt_skillListAction,  
        updateSkillIndexAction:updateSkillIndexAction,
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(AfltSkillDisplayIndexComponent);
